const zIndex = {
  content: 1,
  button: 2,
  header: 10,
  behindContent: -1,
  contentLayer: 20,
};

export default zIndex;
